import './GalleriesByCategoryPage.css';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink, useParams } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import FbImage from '../common/components/fb_image/FbImage';
import { loadGalleriesByCategory } from '../actions/galleryActions';
import { getCategory } from '../actions/categoryActions';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { trackGalleryClick, trackNavigation } from '../common/utils/analytics';
import HomeIcon from '@mui/icons-material/Home';
import SEO from '../common/components/seo/SEO';
import { getBreadcrumbStructuredData } from '../common/utils/structuredData';

function GalleriesByCategoryPage() {

    const dispatch = useDispatch();
    const galleries = useSelector(state => state.gallery.galleriesByCategory);
    const category = useSelector(state => state.category.category);

    const { categoryId } = useParams();

    useEffect(() => {
        dispatch(loadGalleriesByCategory(categoryId));
        dispatch(getCategory(categoryId));
    }, [dispatch, categoryId]);


    const structuredData = getBreadcrumbStructuredData([
        { name: 'Home', url: '/' },
        { name: 'Galleries', url: '/galleries' },
        { name: category?.categoryName || 'Category', url: category?.id ? `/galleries/${category.id}` : undefined },
    ]);

    return (
        <>
            <SEO
                title={category?.categoryName ? `${category.categoryName} - Landscape Photography Galleries` : 'Photo Galleries'}
                description={category?.categoryName 
                    ? `Explore ${category.categoryName} landscape photography galleries by ValeTer. Browse stunning natural scenes and landscapes.`
                    : 'Browse landscape photography galleries organized by category.'}
                keywords={category?.categoryName 
                    ? `${category.categoryName} photography, ${category.categoryName} landscape photos, ${category.categoryName} nature photography`
                    : 'landscape photography galleries'}
                structuredData={structuredData}
            />
            <Paper className='galleries-by-category-page'>
                <Breadcrumbs separator="›" aria-label="breadcrumb" className='enhanced-breadcrumbs'>
                <Link 
                    component={RouterLink}
                    underline="hover" 
                    color="inherit" 
                    to="/"
                    onClick={() => trackNavigation('Breadcrumb: Home')}
                    sx={{ display: 'flex', alignItems: 'center' }}
                >
                    <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
                    Home
                </Link>
                <Link 
                    component={RouterLink}
                    underline="hover" 
                    color="inherit" 
                    to="/galleries"
                    onClick={() => trackNavigation('Breadcrumb: Galleries')}
                >
                    Galleries
                </Link>
                <Typography color="text.primary">{category?.categoryName}</Typography>
            </Breadcrumbs>
            <ImageList
                sx={{
                    width: '100%',
                    overflow: 'hidden',
                    gridTemplateColumns:
                        'repeat(auto-fill, minmax(400px, 12fr))!important',
                    justifyContent: 'center',
                }}
                cols={3}
                gap={8}
            >
                {(galleries ?? []).map((g) => (
                    <ImageListItem key={g.id} className='gallery-card'>
                        <div className='gallery-card-cell'>
                            <RouterLink 
                                className='cell-content' 
                                to={`/galleries/photos/${g.id}`}
                                onClick={() => trackGalleryClick(g.galleryName)}
                            >
                                <FbImage
                                    path={g.coverMediumPath || g.coverPath}
                                    thumbnailPath={g.coverThumbnailPath}
                                    alt={g.galleryName}
                                />
                            </RouterLink>
                            <ImageListItemBar
                                sx={{
                                    '.MuiImageListItemBar-title': {
                                        fontSize: '24px',
                                    },
                                }}
                                title={g.galleryName}
                            />
                        </div>
                    </ImageListItem>
                ))}
            </ImageList>
        </Paper>
        </>
    );
}

export default GalleriesByCategoryPage;
